import { render, staticRenderFns } from "./deductionList.vue?vue&type=template&id=bd90973e&scoped=true"
import script from "./deductionList.vue?vue&type=script&lang=js"
export * from "./deductionList.vue?vue&type=script&lang=js"
import style0 from "./deductionList.vue?vue&type=style&index=0&id=bd90973e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd90973e",
  null
  
)

export default component.exports